import React from 'react';

const PHONE = '+48 536 030 706';
const PHONE_HREF = 'tel:+48536030706';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        padding: '60px 24px 32px',
        background: '#050a1a',
        borderTop: '1px solid rgba(59,130,246,0.1)',
        position: 'relative',
      }}
    >
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: 40,
            marginBottom: 48,
            paddingBottom: 48,
            borderBottom: '1px solid rgba(59,130,246,0.08)',
          }}
        >
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <InfinitiLogo />
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, letterSpacing: '0.15em', color: '#f4f5f7' }}>
                  INFINITI
                </div>
                <div style={{ fontSize: 10, fontWeight: 400, letterSpacing: '0.3em', color: '#3b82f6' }}>
                  FX35
                </div>
              </div>
            </div>
            <p style={{ fontSize: 13, color: 'rgba(244,245,247,0.45)', lineHeight: 1.7, maxWidth: 260 }}>
              Luksusowy wynajem samochodu na wyjątkowe okazje.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3
              style={{
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: '0.3em',
                textTransform: 'uppercase',
                color: '#3b82f6',
                marginBottom: 20,
              }}
            >
              Kontakt
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <a
                href={PHONE_HREF}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  color: 'rgba(244,245,247,0.75)',
                  textDecoration: 'none',
                  fontSize: 14,
                  fontWeight: 500,
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#60a5fa')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(244,245,247,0.75)')}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.22 2 2 0 012 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14z" />
                </svg>
                {PHONE}
              </a>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: 'rgba(244,245,247,0.5)' }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                Województwo mazowieckie
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3
              style={{
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: '0.3em',
                textTransform: 'uppercase',
                color: '#3b82f6',
                marginBottom: 20,
              }}
            >
              Nawigacja
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                { label: 'Strona główna', href: '#home' },
                { label: 'O samochodzie', href: '#about' },
                { label: 'Galeria', href: '#gallery' },
                { label: 'Opinie', href: '#reviews' },
                { label: 'Kontakt', href: '#contact' },
              ].map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(l.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  style={{
                    fontSize: 13,
                    color: 'rgba(244,245,247,0.5)',
                    textDecoration: 'none',
                    transition: 'color 0.2s ease',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = '#f4f5f7')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(244,245,247,0.5)')}
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 12,
          }}
        >
          <p style={{ fontSize: 12, color: 'rgba(244,245,247,0.3)' }}>
            © {year} Infiniti FX35 Wynajem. Wszelkie prawa zastrzeżone.
          </p>
          <p style={{ fontSize: 12, color: 'rgba(244,245,247,0.2)' }}>
            Województwo mazowieckie, Polska
          </p>
        </div>
      </div>
    </footer>
  );
}

function InfinitiLogo() {
  return (
    <svg width="32" height="20" viewBox="0 0 56 28" fill="none">
      <path
        d="M14 14C14 8.477 18.477 4 24 4C27.5 4 30.6 5.8 32.5 8.5L28 14L32.5 19.5C30.6 22.2 27.5 24 24 24C18.477 24 14 19.523 14 14Z"
        stroke="#3b82f6"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M42 14C42 19.523 37.523 24 32 24C28.5 24 25.4 22.2 23.5 19.5L28 14L23.5 8.5C25.4 5.8 28.5 4 32 4C37.523 4 42 8.477 42 14Z"
        stroke="#3b82f6"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  );
}
